var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "商品名称",
                  size: "small",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.load($event)
                  },
                },
                model: {
                  value: _vm.query.keyword,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.query,
                      "keyword",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "query.keyword",
                },
              }),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    placeholder: "商品类型",
                    size: "small",
                  },
                  model: {
                    value: _vm.query.productType,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "productType", $$v)
                    },
                    expression: "query.productType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "普通商品", value: 0 } }),
                  _c("el-option", { attrs: { label: "卡券商品", value: 8 } }),
                ],
                1
              ),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    placeholder: "上架状态",
                    size: "small",
                  },
                  model: {
                    value: _vm.query.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "status", $$v)
                    },
                    expression: "query.status",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "已上架", value: 1 } }),
                  _c("el-option", { attrs: { label: "已下架", value: 0 } }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: { click: _vm.load },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["distribution:store:product:save"],
                      expression: "['distribution:store:product:save']",
                    },
                  ],
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.openCreate },
                },
                [_vm._v("新增商品")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.rows, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "75" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "商品", "min-width": "240" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "product-cell" },
                          [
                            _c("el-image", {
                              staticClass: "thumb",
                              attrs: { src: scope.row.image },
                            }),
                            _c("div", [
                              _c("div", [_vm._v(_vm._s(scope.row.name))]),
                              _c("span", { staticClass: "muted" }, [
                                _vm._v(_vm._s(scope.row.intro)),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "cateName", label: "分类", "min-width": "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "类型", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.productType === 8 ? "warning" : "",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.productType === 8 ? "卡券" : "普通"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "price", label: "售价", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "stock", label: "库存", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sales", label: "销量", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "来源", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(scope.row.source === 0 ? "商品库" : "本店自建")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "上架", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          on: {
                            change: function ($event) {
                              return _vm.toggle(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "230", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["distribution:store:product:update"],
                                expression:
                                  "['distribution:store:product:update']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "distribution:store:product:commission",
                                ],
                                expression:
                                  "['distribution:store:product:commission']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openCommission(scope.row)
                              },
                            },
                          },
                          [_vm._v("淘客设置")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["distribution:store:product:delete"],
                                expression:
                                  "['distribution:store:product:delete']",
                              },
                            ],
                            staticClass: "danger",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.query.page,
              "page-size": _vm.query.limit,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next",
              "page-sizes": [10, 20, 50],
            },
            on: {
              "current-change": _vm.pageChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "编辑商品" : "新增商品",
            visible: _vm.visible,
            width: "860px",
            top: "5vh",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "105px",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.libraryProduct,
                              maxlength: "100",
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品类型" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.libraryProduct },
                              model: {
                                value: _vm.form.productType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "productType", $$v)
                                },
                                expression: "form.productType",
                              },
                            },
                            [
                              _c("el-radio-button", { attrs: { label: 0 } }, [
                                _vm._v("普通商品"),
                              ]),
                              _c("el-radio-button", { attrs: { label: 8 } }, [
                                _vm._v("卡券商品"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "", filterable: "" },
                              model: {
                                value: _vm.form.cateId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "cateId", $$v)
                                },
                                expression: "form.cateId",
                              },
                            },
                            _vm._l(_vm.categories, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "", filterable: "" },
                              model: {
                                value: _vm.brandKey,
                                callback: function ($$v) {
                                  _vm.brandKey = $$v
                                },
                                expression: "brandKey",
                              },
                            },
                            _vm._l(_vm.brands, function (item) {
                              return _c("el-option", {
                                key: item.source + "-" + item.id,
                                attrs: {
                                  label:
                                    "" +
                                    item.name +
                                    (item.source === 1 ? "（本店）" : ""),
                                  value: item.source + "-" + item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "主图地址", prop: "image" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.libraryProduct,
                      placeholder: "图片 URL",
                    },
                    model: {
                      value: _vm.form.image,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "image",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.image",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品简介" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.libraryProduct,
                      type: "textarea",
                      rows: 2,
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.intro,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "intro",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.intro",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品详情" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.libraryProduct,
                      type: "textarea",
                      rows: 4,
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单位" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.libraryProduct },
                            model: {
                              value: _vm.form.unitName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "unitName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.unitName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0, max: 99999 },
                            model: {
                              value: _vm.form.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sort", $$v)
                              },
                              expression: "form.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "立即上架" } },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.form.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.productType !== 8
                ? _c(
                    "el-form-item",
                    { attrs: { label: "履约方式" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.verifyEnabled,
                            callback: function ($$v) {
                              _vm.verifyEnabled = $$v
                            },
                            expression: "verifyEnabled",
                          },
                        },
                        [_vm._v("到店核销")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.expressEnabled,
                            callback: function ($$v) {
                              _vm.expressEnabled = $$v
                            },
                            expression: "expressEnabled",
                          },
                        },
                        [_vm._v("快递发货")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("规格与库存"),
              ]),
              _c(
                "el-table",
                { attrs: { data: _vm.form.skuList, border: "", size: "mini" } },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "sku", label: "规格", "min-width": "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                disabled: _vm.form.specType === 1,
                                placeholder: "默认",
                              },
                              model: {
                                value: scope.row.sku,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "sku",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.sku",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "售价", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: { min: 0, precision: 2, controls: false },
                              model: {
                                value: scope.row.price,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "price", $$v)
                                },
                                expression: "scope.row.price",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "划线价", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: { min: 0, precision: 2, controls: false },
                              model: {
                                value: scope.row.otPrice,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "otPrice", $$v)
                                },
                                expression: "scope.row.otPrice",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "成本", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: { min: 0, precision: 2, controls: false },
                              model: {
                                value: scope.row.cost,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "cost", $$v)
                                },
                                expression: "scope.row.cost",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "库存", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: { min: 0, precision: 0, controls: false },
                              model: {
                                value: scope.row.stock,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "stock", $$v)
                                },
                                expression: "scope.row.stock",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.form.productType === 8
                ? [
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("卡券规则")]
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "卡券类型" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.form.cardConfig.cardType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.cardConfig,
                                          "cardType",
                                          $$v
                                        )
                                      },
                                      expression: "form.cardConfig.cardType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "次卡", value: 1 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "周期卡", value: 2 },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.form.cardConfig.cardType === 1
                          ? _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "可用次数" } },
                                  [
                                    _c("el-input-number", {
                                      attrs: { min: 1 },
                                      model: {
                                        value: _vm.form.cardConfig.cardTimes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.cardConfig,
                                            "cardTimes",
                                            $$v
                                          )
                                        },
                                        expression: "form.cardConfig.cardTimes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "有效期" } },
                                  [
                                    _c("el-input-number", {
                                      attrs: { min: 1 },
                                      model: {
                                        value: _vm.form.cardConfig.validNum,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.cardConfig,
                                            "validNum",
                                            $$v
                                          )
                                        },
                                        expression: "form.cardConfig.validNum",
                                      },
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "unit",
                                        model: {
                                          value: _vm.form.cardConfig.validUnit,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.cardConfig,
                                              "validUnit",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.cardConfig.validUnit",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "天", value: "day" },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "月",
                                            value: "month",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "年", value: "year" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "有效期起算" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.form.cardConfig.validStartType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.cardConfig,
                                          "validStartType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.cardConfig.validStartType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "下单后", value: 1 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "首次核销后", value: 2 },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "核销频次" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value:
                                        _vm.form.cardConfig.verifyFrequency,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.cardConfig,
                                          "verifyFrequency",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.cardConfig.verifyFrequency",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "不限", value: 0 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "每天一次", value: 1 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "每周一次", value: 2 },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "每月一次", value: 3 },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "附加规则" } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.form.cardConfig.supportRefund,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.cardConfig,
                                  "supportRefund",
                                  $$v
                                )
                              },
                              expression: "form.cardConfig.supportRefund",
                            },
                          },
                          [_vm._v("支持七天售后")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "form-tip",
                            staticStyle: {
                              "margin-left": "12px",
                              color: "#999",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v("卡券过期未使用将自动退款")]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.submit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "商品淘客设置",
            visible: _vm.commissionVisible,
            width: "640px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.commissionVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.commission,
                "label-width": "110px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "开启淘客" } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.commission.commissionOpen,
                      callback: function ($$v) {
                        _vm.$set(_vm.commission, "commissionOpen", $$v)
                      },
                      expression: "commission.commissionOpen",
                    },
                  }),
                ],
                1
              ),
              _vm.commission.commissionOpen === 1
                ? [
                    _vm._l(_vm.rewardFields, function (item) {
                      return _c(
                        "el-form-item",
                        { key: item.value, attrs: { label: item.label } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              model: {
                                value: _vm.commission[item.type],
                                callback: function ($$v) {
                                  _vm.$set(_vm.commission, item.type, $$v)
                                },
                                expression: "commission[item.type]",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "固定佣金", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "积分", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "佣金比例", value: 3 },
                              }),
                            ],
                            1
                          ),
                          _c("el-input-number", {
                            staticClass: "reward-value",
                            attrs: {
                              min: 0,
                              max:
                                _vm.commission[item.type] === 3 ? 100 : 999999,
                              precision: 2,
                            },
                            model: {
                              value: _vm.commission[item.value],
                              callback: function ($$v) {
                                _vm.$set(_vm.commission, item.value, $$v)
                              },
                              expression: "commission[item.value]",
                            },
                          }),
                          _c("span", { staticClass: "reward-unit" }, [
                            _vm._v(
                              _vm._s(
                                _vm.commission[item.type] === 3
                                  ? "%"
                                  : _vm.commission[item.type] === 2
                                  ? "积分"
                                  : "元"
                              )
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                    _c("el-alert", {
                      attrs: {
                        title:
                          "直推和间推奖励发给两级推广关系；团队奖励仅对符合周期条件的团长计提。",
                        type: "info",
                        closable: false,
                        "show-icon": "",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.commissionVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.commissionSaving },
                  on: { click: _vm.saveCommission },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }